/**
 * assets/ga4-custom-events.js
 * Gedrag van snippets/ga4-custom-events.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

(function() {
  'use strict';

  /* ═══ Helper: veilig gtag aanroepen ═══ */
  function track(eventName, params) {
    if (typeof gtag === 'function') {
      gtag('event', eventName, params || {});
    }
  }

  /* ═══ 1. URGENTIE-SIGNALEN ═══ */
  /* Observeer wanneer urgentie-badges zichtbaar worden */
  const urgencyEls = document.querySelectorAll('[data-urgency-signal]');
  if (urgencyEls.length > 0) {
    const urgencyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const signalType = el.dataset.urgencySignal || 'unknown';
          const productId = el.dataset.productId || '';
          track('urgency_signal_view', {
            event_category: 'urgentie',
            signal_type: signalType,
            product_id: productId
          });
          urgencyObserver.unobserve(el);
        }
      });
    }, { threshold: 0.5 });
    urgencyEls.forEach(el => urgencyObserver.observe(el));
  }

  /* ═══ 2. BUNDEL INTERACTIES ═══ */
  const bundelEls = document.querySelectorAll('[data-bundel-view]');
  if (bundelEls.length > 0) {
    const bundelObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          track('bundle_view', {
            event_category: 'bundel',
            bundle_id: el.dataset.bundelView || '',
            savings: parseFloat(el.dataset.bundelSavings) || 0
          });
          bundelObserver.unobserve(el);
        }
      });
    }, { threshold: 0.5 });
    bundelEls.forEach(el => bundelObserver.observe(el));
  }

  /* Bundel add-to-cart click tracking */
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-bundel-add]');
    if (btn) {
      track('bundle_add_to_cart', {
        event_category: 'bundel',
        bundle_id: btn.dataset.bundelAdd || '',
        value: parseFloat(btn.dataset.bundelValue) || 0
      });
    }
  });

  /* ═══ 3. FREE SHIPPING BAR ═══ */
  /* Luister naar free-shipping-reached event (gedispatched door free-shipping-bar.liquid) */
  document.addEventListener('free-shipping-reached', function(e) {
    track('free_shipping_reached', {
      event_category: 'shipping',
      cart_value: e.detail?.cartValue || 0
    });
  });

  /* ═══ 4. SEARCH EVENTS ═══ */
  /* Zero results tracking */
  const searchForm = document.querySelector('form[action="/search"]');
  if (searchForm) {
    /* Luister naar zoekresultaten pagina */
    if (window.location.pathname === '/search') {
      const resultsCount = document.querySelectorAll('.search-result, [data-search-result]').length;
      const params = new URLSearchParams(window.location.search);
      const searchTerm = params.get('q') || '';
      
      if (resultsCount === 0 && searchTerm) {
        track('search_zero_results', {
          event_category: 'search',
          search_term: searchTerm
        });
      }
    }
  }

  /* Synonym expansion tracking */
  if (window.vcSynonyms) {
    const originalLookup = window.vcSynonyms.lookup;
    window.vcSynonyms.lookup = function(query) {
      const results = originalLookup(query);
      if (results && results.length > 0) {
        track('search_synonym_match', {
          event_category: 'search',
          original_term: query,
          synonyms_found: results.length,
          synonyms: results.slice(0, 5).join(', ')
        });
      }
      return results;
    };
  }

  /* ═══ 5. GALLERY INTERACTIES ═══ */
  /* Desktop: thumbnail clicks */
  document.querySelectorAll('[data-thumb]').forEach(thumb => {
    thumb.addEventListener('click', function() {
      track('gallery_slide_change', {
        event_category: 'gallery',
        slide_index: this.dataset.thumb,
        interaction: 'thumbnail_click'
      });
    });
  });

  /* Desktop: zoom click */
  const galleryMain = document.querySelector('[data-gallery-main]');
  if (galleryMain) {
    galleryMain.addEventListener('click', function(e) {
      if (e.target.closest('.pdp-zoom-wrap img, .pdp-zoom-img')) {
        track('gallery_zoom', {
          event_category: 'gallery',
          interaction: 'zoom_click'
        });
      }
    });
  }

  /* ═══ 6. STICKY CTA ═══ */
  const stickyCta = document.querySelector('[data-sticky-cta]');
  if (stickyCta) {
    stickyCta.addEventListener('click', function(e) {
      const btn = e.target.closest('button, a');
      if (btn) {
        track('sticky_cta_click', {
          event_category: 'cta',
          cta_type: btn.dataset.ctaType || 'add_to_cart'
        });
      }
    });
  }

  /* ═══ 7. BOTTOM-SHEET OPENS ═══ */
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-open-sheet]');
    if (trigger) {
      track('bottom_sheet_open', {
        event_category: 'interaction',
        sheet_id: trigger.dataset.openSheet || 'unknown'
      });
    }
  });

  /* ═══ 8. SCROLL DEPTH (25%, 50%, 75%, 100%) ═══ */
  const scrollMarks = { 25: false, 50: false, 75: false, 100: false };
  let scrollTicking = false;
  
  window.addEventListener('scroll', function() {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function() {
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) { scrollTicking = false; return; }
      const pct = Math.round((window.scrollY / docHeight) * 100);
      
      [25, 50, 75, 100].forEach(mark => {
        if (pct >= mark && !scrollMarks[mark]) {
          scrollMarks[mark] = true;
          track('scroll_depth', {
            event_category: 'engagement',
            percent_scrolled: mark,
            page_path: window.location.pathname
          });
        }
      });
      scrollTicking = false;
    });
  }, { passive: true });

})();
